import { render, staticRenderFns } from "./BusinessSubscriptionReport.vue?vue&type=template&id=f4031d98&scoped=true"
import script from "./BusinessSubscriptionReport.vue?vue&type=script&lang=js"
export * from "./BusinessSubscriptionReport.vue?vue&type=script&lang=js"
import style0 from "./BusinessSubscriptionReport.vue?vue&type=style&index=0&id=f4031d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4031d98",
  null
  
)

export default component.exports